import config from '../../config/api';

export const serializeService = (service) =>({
    id: service['id'],
    name: service['Nome'],
    description: service['Descricao'],
    text: service['Texto'],
    photo: serializePhoto(service['Foto']),
});

export const serializePhoto = (media) =>({
    url: config.API_HOST + media.url,
});

export const serializeEditorial = ({
    id, companyLongDescription, companyShortDescription, galleryImages=[], 
    homeHeaderImage= {}, aboutHeaderImage = {}, 
    productHeaderImage = {}, servicesHeaderImage = {},
} = {}) => ({
    id,
    companyLongDescription,companyShortDescription,
    galleryImages: galleryImages.map(serializePhoto),
    homeHeaderImage: serializePhoto(homeHeaderImage),
    aboutHeaderImage: serializePhoto(aboutHeaderImage),
    productsHeaderImage: serializePhoto(productHeaderImage),
    servicesHeaderImage: serializePhoto(servicesHeaderImage)
});

export const serializeContact = (contact) =>({
    id: contact['id'],
    type: contact['Tipo'],
    name: contact['Nome'],
    phone: contact['Telefone'],
    email: contact['Email'],
    address: contact['Morada'],
});

export const serializeProductType = (productType) => ({
    id: productType['id'],
    name: productType['Nome'],
    products: productType.produtos.map(({id}) => id)
});

export const serializeProduct = (product) => ({
    id: product['id'],
    name: product['Nome'],
    description: product['Caracteristicas'],
    photo: serializePhoto(product['Foto']),
});